<template>
  <SystemDate class="flex h-full items-center rounded-sm hover:cursor-pointer" :class="[isSelected ? 'bg-gold4 text-white' : 'border-transparent', noHover || isSelected ? '' : 'md:hover:bg-beige2']">
    <template #day>
      <span class="font-Spectral text-base font-light leading-tight md:leading-loose" :class="[disabled ? 'text-neutral-400' : 'text-stone-700', isSelected && 'text-white']">
        {{ day.slice(day.length - 2).replace(/^0/, '') }}
      </span>
    </template>
  </SystemDate>
</template>

<script setup lang="ts">
import SystemDate from '@/components/system/Date/Date.vue';

interface Props {
  day: string;
  isSelected?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});

const noHover = computed(() => props.disabled);
</script>
